import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfigTable from './components/ConfigTable';
import ConfigFormModal from './components/ConfigFormModal';
import {
    listConfigs,
    createConfig,
    updateConfig,
    activateConfig,
    deleteConfig,
} from './api';
import './referral-config.css';

export default function ReferralConfigPage() {
    const navigate = useNavigate();
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [modalMode, setModalMode] = useState(null);
    const [editing, setEditing] = useState(null);

    const load = async () => {
        setLoading(true);
        setError('');
        try {
            const data = await listConfigs();
            setConfigs(data);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let active = true;
        Promise.resolve()
            .then(listConfigs)
            .then((data) => {
                if (active) setConfigs(data);
            })
            .catch((e) => {
                if (active) setError(e.message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    const openCreate = () => {
        // Go to simulator
        navigate('/super-admin/referral-simulator');
    };

    const openEdit = (config) => {
        setEditing(config);
        setModalMode('edit');
    };

    const closeModal = () => {
        setModalMode(null);
        setEditing(null);
    };

    const handleSubmit = async (payload) => {
        setSaving(true);
        setError('');
        setMessage('');
        try {
            if (modalMode === 'edit' && editing) {
                await updateConfig(editing.id, payload);
                setMessage('تنظیمات با موفقیت ویرایش شد.');
            } else {
                await createConfig(payload);
                setMessage('تنظیمات جدید با موفقیت ایجاد شد.');
            }
            closeModal();
            await load();
        } catch (e) {
            setError(e.message);
            throw e;
        } finally {
            setSaving(false);
        }
    };

    const handleActivate = async (id) => {
        if (!window.confirm('این برنامه فعال شود؟ بقیه برنامه‌ها غیرفعال خواهند شد.')) {
            return;
        }
        setSaving(true);
        setError('');
        setMessage('');
        try {
            await activateConfig(id);
            setMessage('برنامه با موفقیت فعال شد.');
            await load();
        } catch (e) {
            setError(e.message);
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('این برنامه حذف شود؟ این عمل غیرقابل بازگشت است.')) {
            return;
        }
        setSaving(true);
        setError('');
        setMessage('');
        try {
            await deleteConfig(id);
            setMessage('برنامه حذف شد.');
            await load();
        } catch (e) {
            setError(e.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="referral-config-page">
            <header className="page-header">
                <h1>تنظیمات برنامه پورسانت</h1>
                <p>مدیریت برنامه‌های پورسانت زنجیره‌ای</p>
                <button className="btn-new-config" onClick={openCreate}>
                    + برنامه جدید
                </button>
            </header>

            {message && <div className="success-banner">{message}</div>}
            {error && <div className="error-banner">{error}</div>}

            {loading ? (
                <div className="loading">در حال بارگذاری...</div>
            ) : (
                <ConfigTable
                    configs={configs}
                    onEdit={openEdit}
                    onActivate={handleActivate}
                    onDelete={handleDelete}
                    loading={saving}
                />
            )}

            {modalMode === 'edit' && (
                <ConfigFormModal
                    mode={modalMode}
                    config={editing}
                    onClose={closeModal}
                    onSubmit={handleSubmit}
                    loading={saving}
                />
            )}
        </div>
    );
}